<script>
  import Swal from "sweetalert2";
  import Timesheet from "../containers/Timesheet.svelte";
  import TabTimesheet from "../containers/TabTimesheet.svelte";
  import Select from "svelte-select";
  import NavbarSuccess from "../NavbarSuccess.svelte";
  import DataSpinner from "../Spinner.svelte";
  import NewTimesheetModal from "../NewTimesheetModal.svelte";
  import RejectModal from "../RejectModal.svelte";
  import Icon from "svelte-awesome";
  import { chevronLeft, chevronRight } from "svelte-awesome/icons";
  import { navigate } from "svelte-routing";
  import { Spinner } from "sveltestrap";
  import { onMount, setContext } from "svelte";
  import axios from "axios";
  import {
    addWeeks,
    setDay,
    addMinutes,
    format,
    parse,
    isValid,
    isMonday,
    previousMonday
  } from "date-fns";
  import { getMsalInstance } from "../../msal-config.js";

  const MONDAY = 1;
  const LOCAL_TIMEZONE_OFFSET = new Date().getTimezoneOffset();
  const DATE_INPUT_FORMAT = 'yyyy-MM-dd';
  const DATE_MODAL_FORMAT = 'MM/dd/yyyy';

  let currentDate = isMonday(new Date()) ? new Date() : previousMonday(new Date());
  const urlParams = new URLSearchParams(window.location.search);
  const weekStartUTC = urlParams.get("week");
  const staffName = urlParams.get("staff");
  const staffId = urlParams.get("staffId");

  const weekStartUTCDate = !!weekStartUTC && isValid(new Date(weekStartUTC)) ? new Date(weekStartUTC) : currentDate;

  let msalInstance = null;

  let submitting = false;
  let approving = false;
  let date = format(weekStartUTCDate, DATE_INPUT_FORMAT);

  let modaldate = format(weekStartUTCDate, DATE_MODAL_FORMAT);
  let staff = null;
  let admin = true;
  let staffArray = [];
  let defaultUser;
  let items = [];
  let data = null;
  let fetching_timesheet = false;
  let user = null;
  let newdate = modaldate;
  let timeout;
  let open = false;
  const toggle = () => (open = !open);
  let open_success = false;
  let toggle_success = () => (open_success = !open_success);
  let open_reject = false;
  const toggle_reject = () => (open_reject = !open_reject);

  let sample = false;

  let timesheetId = null;
  const timesheetContext = {
    getCurrentTimesheetId: () => timesheetId,
    refreshTimesheet: () => handleSearch(),
  };
  setContext('timesheet', timesheetContext);

  onMount(async () => {
    await initializeMFA();
    await getJobs();
    await getUser();
  });

  async function initializeMFA() {
    msalInstance = await getMsalInstance();
    await msalInstance.initialize();
  }

  async function handleLogout() {
    logoutMFA();
    const res = await fetch("/authentication/logout");
    const json = await res.json();

    navigate("/Login", { replace: true });
    document.title = "Login";
  }

  function logout() {
    handleLogout();
  }

  function getWeek() {
    date = format(currentDate, DATE_INPUT_FORMAT);
    modaldate = format(currentDate, DATE_MODAL_FORMAT);
    newdate = modaldate;
  }

  async function getStaff() {
    const res = await fetch("/timesheetapi/getstaff");
    const json = await res.json();
    staffArray = json.Result;
    if (user.Type !== 1) {
      if (weekStartUTC != null) {
        currentDate = weekStartUTCDate;
        getWeek();
        handleSearch();
      }
    }
  }

  async function getUser() {
    const res = await fetch("/authentication/GetUserDetails");
    const json = await res.json();
    user = json.Result;
    if (json.StatusCode === 401) {
      window.location = "login" + window.location.search;
      document.title = "Login";
    } else {
      if (user.Type === 1) {
        document.onmousemove = function() {
          clearTimeout(timeout);
          timeout = setTimeout(function() {
            handleLogout();
          }, 60000 * 25);
        };
      }
    }
    if (staffName != null) {
      defaultUser = staffName;
      staff = staffId;
    } else {
      defaultUser = user.Name;
      staff = user.ID;
    }

    getStaff();
  }

  function authenticate(status) {
    if (status === 401) {
    }
  }
  async function getJobs() {
    await axios
      .get("/timesheetapi/BuildJob?prefixText=" + " ")
      .then(function(response) {
        console.log(response);
      })
      .catch(function(error) {
        console.log(error);
      });
  }
  async function searchTimesheet() {
    fetching_timesheet = true;
    const newdate = format(parse(date, DATE_INPUT_FORMAT, new Date()), DATE_MODAL_FORMAT);
    const res = await fetch(
      "/timesheetapi/RetrieveTimesheets?startweek=" +
        newdate +
        "&staffId=" +
        (user.Type === 1 ? user.ID : staff)
    );
    const json = await res.json();
    if (json.StatusCode === 401) {
      handleLogout();
    } else {
      data = json;
      timesheetId = data.Result.TimesheetId;
      fetching_timesheet = false;
    }
  }

  async function submitApprove() {
    approving = true;
    const newdate = format(parse(date, DATE_INPUT_FORMAT, new Date()), DATE_MODAL_FORMAT);
    const approve_data = {
      startweek: newdate,
      staffId: staff
    };
    const res = await fetch("/timesheetapi/ApproveTimesheet", {
      method: "POST",
      headers: {
        "Content-type": "application/json"
      },
      body: JSON.stringify(approve_data)
    });
    const status = await res.status;
    approving = false;
    if (status === 200) {
      Swal.fire({
        icon: "success",
        title: "Timesheet approved",
        showConfirmButton: false,
        timer: 2000
      });
      document.getElementById("btn-search").click();
    }
  }

  async function submit() {
    submitting = true;
    const newdate = format(parse(date, DATE_INPUT_FORMAT, new Date()), DATE_MODAL_FORMAT);
    const approve_data = {
      startweek: newdate,
      staffId: user.Type === 1 ? user.ID : staff
    };
    const res = await fetch("/timesheetapi/SubmitForApproval", {
      method: "POST",
      headers: {
        "Content-type": "application/json"
      },
      body: JSON.stringify(approve_data)
    });
    const status = await res.status;
    submitting = false;
    if (status === 200) {
      open_success = true;
      document.getElementById("btn-search").click();
    }
  }

  function handleChangeValue(e) {
    staff = e.target.value;
    data = null;
  }

  function handleSearch() {
    data = null;
    searchTimesheet();
  }

  function handleApprove() {
    approving = true;
    submitApprove();
  }

  function handleSubmit() {
    submit();
  }

  function handleChangeDate(e) {
    date = e.target.value;
    data = null;
    newdate = format(parse(date, DATE_INPUT_FORMAT, new Date()), DATE_MODAL_FORMAT);
  }

  function prevWeek() {
    const value = setDay(addWeeks(new Date(date), -1), MONDAY);
    date = format(value, DATE_INPUT_FORMAT);
    newdate = format(value, DATE_MODAL_FORMAT);
    searchTimesheet();
  }

  function nextWeek() {
    const value = setDay(addWeeks(new Date(date), 1), MONDAY);
    date = format(value, DATE_INPUT_FORMAT);
    newdate = format(value, DATE_MODAL_FORMAT);
    searchTimesheet();
  }

  function isAdminAsync() {
    return new Promise(resolve => {
      const isAdminJson = sessionStorage.getItem('is_admin');
      if (!!isAdminJson) {
        resolve(!!JSON.parse(isAdminJson));
        return;
      }

      const intervalId = setInterval(() => {
        const isAdminJson = sessionStorage.getItem('is_admin');
        if (!!isAdminJson) {
          resolve(!!JSON.parse(isAdminJson));
        }
      }, 100);
    });
  }

  function logoutMFA() {
    if (!!sessionStorage.getItem("msal.account.keys")) {
      const logoutRequest = {
        account: msalInstance.getActiveAccount(),
        onRedirectNavigate: () => false
      };

      msalInstance.clearCache(logoutRequest);
    }
  }
</script>

<style>
  .main-home {
    padding: 1em;
    margin: 0 auto;
    height: 100%;
    text-align: center;
    width: 70%;
    color: #4e575a;
    display: flex;
  }
  .approval-container {
    padding: 0px;
    margin-left: 35px;
  }
  .button-move {
    padding: 11px;
    border: 1px solid #b2bec3;
    border-radius: 5px;
    height: 85%;
  }
  .approval-container button {
    border: none;
    padding: 5px 10px;
    border-radius: 5px;
    width: 100%;
  }
  input {
    width: 100%;
    margin-bottom: 10px;
    padding: 10px;
    border: 1px solid #b2bec3;
    border-radius: 5px;
    display: inline-block;
  }
  select {
    width: 100%;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #b2bec3;
  }
  .search-timesheet-container {
    width: 100%;
    border-radius: 5px;
    border: 1px solid #b2bec3;
  }

  .search-timesheet-form {
    padding: 20px;
    display: flex;
    width: 100%;
  }
  .search-timesheet-title {
    border-bottom: 1px solid #b2bec3;
    padding: 10px 0;
    background-color: #dcdde1;
    border-radius: 5px 5px 0px 0px;
    text-align: left;
    padding: 10px 15px;
  }
  .button-primary {
    background-color: #3498db;
    border: none;
    color: white;
    padding: 5px 10px;
    border-radius: 5px;
    width: 20%;
  }
  .button-secondary {
    background-color: #2ecc71;
    border: none;
    color: white;
    padding: 5px 10px;
    border-radius: 5px;
    width: 20%;
  }
  .btn-approve {
    background-color: #1dd1a1;
    color: white;
    margin-top: 60px;
    margin-bottom: 30px;
  }
  .btn-reject {
    background-color: #ff6b6b;
    color: white;
  }
  .total-hours-container {
    padding: 20px;
    font-size: 20px;
    text-align: center;
    display: flex;
    justify-content: right;
    padding-bottom: 0px;
    margin-bottom: -30px;
  }
  .total-hours-text-block {
    display: grid;
    grid-template-columns: 1fr auto; /* Two equal columns */
    row-gap: 0px;
    column-gap: 5px;
  }
  .total-hours-text-block > * {
    margin-bottom: -6px;
  }
  .total-hours-text-block > .subtext {
    font-size: 80%;
  }
  .total-hours-text-block > dt {
    text-align: right;
    font-weight: normal;
  }
  .total-hours-text-block > dd {
    text-align: left;
  }
  button:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  .tooltip-container {
    position: relative;
    display: inline-block;
    cursor: pointer;
  }

  .tooltip-container .tooltip-text {
    visibility: hidden;
    width: 300px;
    background-color: #000;
    color: #fff;
    font-size: 11px;
    text-align: left;
    border-radius: 2px;
    padding: 5px;
    position: absolute;
    bottom: 0%;
    left: 0%;
    transform: translateX(-100%);
    opacity: 0;
    transition: opacity 0.3s;
  }

  .tooltip-container:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
  }

  @media (max-width: 1024px) {
    .main-home {
      width: 80%;
    }
  }
  @media (max-width: 768px) {
    main {
      width: 100% !important;
    }
    .search-timesheet-form {
      width: 100% !important;
    }
  }
  @media (max-width: 426px) {
    .timesheet-label {
      display: block;
    }
    .date-row {
      display: unset;
    }
    .main-home {
      display: unset;
    }
    .approval-container {
      display: flex;
      justify-content: center;
      margin-left: 0px;
    }
    .approval-container button {
      margin-top: 0px;
      margin: 10px;
    }
    .search-timesheet-form {
      padding: 20px 0px 20px 0px;
    }
  }
  @media (max-width: 375px) {
    .search-timesheet-form {
      padding-bottom: 0px !important;
    }
    button {
      display: block;
      width: 80%;
      margin: 0 auto;
      margin-bottom: 5px;
    }
  }
  .disable {
    cursor: not-allowed;
    opacity: 0.5;
  }
  .timesheet-label {
    margin-right: 20px;
  }
  .timesheet-form-content {
    width: 80%;
    margin: 0 auto;
  }
  .date-row {
    display: flex;
  }
  .timesheet-staff-label {
    margin-right: 26px;
  }
  @media (max-width: 426px) {
    .timesheet-label {
      display: block;
    }

    .timesheet-staff-label {
      display: block;
    }
    .form-button {
      display: block;
      width: 100% !important;
      margin: 8px 0;
    }
    .date-row {
      display: unset;
    }
  }
  .btn-download {
    background: none !important;
    border: none !important;
  }
</style>

<NavbarSuccess>
  <ul>
    <li style="background-color:  #304c63;">
      <a href="/timesheet">Timesheets</a>
    </li>
    {#await isAdminAsync()}
      &nbsp;
    {:then is_admin}
      {#if is_admin}
        <li>
          <a href="/ptoapproval">PTO Pending for Approval</a>
        </li>
      {/if}
    {/await}
  </ul>
</NavbarSuccess>
<main class="main-home">
  <div class="search-timesheet-container">
    <div class="search-timesheet-title">Search Timesheet</div>
    <div class="search-timesheet-form">
      <div class="timesheet-form-content">
        <div class="date-row">
          <label class="timesheet-label">Week</label>
          <div style="display:flex; width: 100%; margin-bottom: 10px">
            <button
              on:click={prevWeek}
              class="button-move"
              style="margin-right: 7px">
              <Icon data={chevronLeft} />
            </button>
            <input
              type="date"
              value={date}
              id="timesheet-date"
              on:change={handleChangeDate} />
            <button
              on:click={nextWeek}
              class="button-move"
              style="margin-left: 7px">
              <Icon data={chevronRight} />
            </button>
          </div>
        </div>
        <div class="date-row">
          {#if admin}
            <label class="timesheet-staff-label">Staff</label>
            {#if user === null}
              <select>
                <option />
              </select>
              <Spinner
                size="sm"
                style="margin-right:-22px; margin-top: 12px; margin-left: 7px;" />
            {:else if user !== null}
              {#if user.Type !== 1}
                <select value={staff} on:change={handleChangeValue}>
                  {#each staffArray as staff}
                    <option
                      value={staff.staffId}
                      selected={staff.staffName === defaultUser ? true : false}>
                      {staff.staffName}
                    </option>
                  {/each}
                </select>
              {:else}
                <div
                  style="width: 100%; padding: 10px; border: 1px solid #b2bec3;
                  border-radius: 5px; color: black;">
                  {user.Name}
                </div>
              {/if}
            {/if}
          {/if}
        </div>
        <div style="margin-top: 15px" class="date-row">
          <label style="margin-right: 3px; color: white !important;">
            Buttons
          </label>
          {#if staffArray.length === 0 || newdate === '//'}
            <button
              id="btn-search"
              on:click={handleSearch}
              class="button-primary form-button"
              style="margin-right:10px"
              disabled={staff == null ? true : false}>
              Search
            </button>
          {:else}
            <button
              id="btn-search"
              on:click={handleSearch}
              class="button-primary form-button"
              style="margin-right:10px"
              disabled={staff == null ? true : false}>
              Search
            </button>
          {/if}
          {#if data !== null}
            {#if data.Result.Status !== 1 && data.Result.Status !== 2}
              <button
                on:click={toggle}
                class="button-secondary form-button"
                style="margin-right: auto;">
                New Time Entry
              </button>
            {/if}
          {/if}
          {#if data !== null}
            {#if data.Result.TotalWeekHours !== 0}
              {#if data.Result.Status === 3 || data.Result.Status === 0}
                {#if submitting}
                  <button on:click={handleSubmit} class="button-secondary">
                    <Spinner size="sm" />
                    Submitting
                  </button>
                {:else}
                  <button
                    on:click={handleSubmit}
                    class="button-secondary form-button">
                    Submit
                  </button>
                {/if}
              {/if}
            {/if}
          {/if}
        </div>
      </div>
    </div>
  </div>
  {#if user !== null && data !== null}
    {#if user.Type === 2}
      {#if data.Result.Status !== 0}
        {#if data.Result.TotalWeekHours !== 0}
          <div class="approval-container">
            {#if approving}
              <button class="btn-approve disable" on:click={handleApprove}>
                <Spinner size="sm" />
                Approving
              </button>
            {:else}
              <button
                class="btn-approve"
                disabled={data.Result.Status === 2 ? true : false}
                on:click={handleApprove}>
                Approve Timesheet
              </button>
            {/if}
            <button
              class="btn-reject"
              disabled={data.Result.Status === 3 ? true : false}
              on:click={toggle_reject}>
              Reject Timesheet
            </button>
          </div>
        {/if}
      {/if}
    {/if}
  {/if}
</main>
{#if data !== null}
  <div class="total-hours-container">
    <dl class="total-hours-text-block">
      <dt>Total Hours of the Week:</dt>
      <dd>
        {#if data !== null}{data.Result.TotalWeekHours}h{/if}
        <a
          href={'../timesheetapi/DownloadTimesheets?startWeek=' + newdate + '&staffId=' + (user.Type === 1 ? user.ID : staff)}>
          <button
            class="btn-download"
            style={newdate === undefined ? 'cursor: not-allowed; opacity: 0.5' : ''}
            disabled={newdate === undefined ? true : false}>
            <i class="fas fa-download" style="color:#000" />
          </button>
        </a>
      </dd>
      <dt class="subtext">Total PTO Hours:</dt>
      <dd class="subtext">{data.Result.TotalPTOHours}h</dd>
      <dt class="subtext">
        <div class="tooltip-container">
          <i class="fa fa-info-circle fa-fw"></i>
          <span class="tooltip-text">Please note that the calculation of overtime shown on your timesheet is for internal tracking purposes only and may differ from the methods required by California state labor laws. Final overtime pay is determined in accordance with applicable legal standards.</span>
        </div>
        Total OT Hours:
      </dt>
      <dd class="subtext">{data.Result.TotalOTHours}h</dd>
    </dl>
  </div>
{/if}
{#if fetching_timesheet}
  <DataSpinner />
{:else if data !== null}
  <Timesheet {modaldate} {newdate} {data} {staff} user={user.Type} />
  <TabTimesheet {modaldate} {newdate} {data} {staff} />
{/if}
{#if date !== null && staff !== null}
  <NewTimesheetModal
    {open}
    {toggle}
    date={newdate}
    staffid={staff}
    on:reloadSearch={handleSearch} />
  <RejectModal
    open={open_reject}
    toggle={toggle_reject}
    {newdate}
    staffid={staff} />
{/if}
